{
  "signedInAs": "Connecté en tant que {{username}}"
}
